import { RichText } from "@wordpress/block-editor";
import { useContext } from "@wordpress/element";
import placeholderImageUrl from '../../../../includes/assets/img/profile-image.png';
import icons from '../../../options/icons';
import BlockContext from '../context/blockContext';
import QrCode from './QrCode';


const HeaderOne = () => {
	const { attributes, showSocialIcon, socialIconVisibility, headerComponent, linkedinText, canvasRef, currentData, updateDataByStyleField } = useContext(BlockContext);
	const { profileImage, socialIcon, showQRCode } = attributes;
	return (
        <>
            <div className="profile-img">
                {profileImage && profileImage.url ? (
                    <img src={profileImage.url} alt={profileImage.alt || 'Profile Image'} />
                ) : (
                    <img src={placeholderImageUrl} alt="Placeholder" />
                )}
            </div>
            <div className="profile-info">
                <div className="bwdcv-name-wrap">
                    <RichText
                        tagName="span"
                        className="first-name"
                        value={ currentData.firstName }
                        onChange={(value) => updateDataByStyleField('firstName', value)}
                />
                <RichText
                    tagName="span"
                    className="last-name"
                    value={ currentData.lastName }
                    onChange={(value) => updateDataByStyleField('lastName', value)}
                />
            </div>
                <RichText
                    className="designation"
                    value={ currentData.designation }
                    onChange={(value) => updateDataByStyleField('designation', value)}
                />
                {
                    (showSocialIcon && socialIconVisibility) &&(
                    <div className="social-icon" >
                        {
                            socialIcon && socialIcon.map((item, index) => {
                                return item.link ? (
                                    <a key={index} href={item.link} target="_blank" rel="noopener noreferrer">
                                        <span className="icon">{icons[item.icon]}</span>
                                    </a>
                                ) : (
                                    <span key={index} className="icon disabled">
                                        {icons[item.icon]}
                                    </span>
                                );
                            })
                        }
                    </div>
                    )
                }
                {headerComponent}
        </div>
        {showQRCode && (
            <div className="cv-qrWrapper">
           <QrCode tokenUrl={userData.tokenUrl} />
            {/* Custom Linkedin Text */}
            {linkedinText}
        </div>
        )}
        </>
	);
};

export default HeaderOne;